import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Link from 'components/link';
import Row, { Col } from 'components/row';
import { Maps, InfoLayer, BaseLayersUser } from 'containers/maps';

import links from 'src-sites/bildcontrol/links';

import marker from '../../assets/map-marker';

import translates from '../contacts-i18n.json';

const classes = new Bem('blockContacts');

@I18nHoc(translates)
export default class ContactsBlock extends Component {
  static propTypes = {
    className: PropTypes.string,
    topic: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { className, topic } = this.props;
    const geo_centroid = {
      coordinates: [30.466934, 50.521863],
      parameters: { distance: 10000 },
      type: 'Point'
    };
    const phoneHref = '+380986563402';
    const phoneText = '+380(98) 656 34 02';

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'topic')}>
          <Col allPr={0}><span {...classes('text', 'h1')}><h1 children={topic || i18n('contactsH1')} /></span></Col>
        </Row>
        <Row {...classes('row', 'block')}>
          <Col {...classes('col', 'map')} allAuto allPr={0}>
            <div {...classes('mapContainer')}>
              <Maps
                {...classes('map')}
                noAutoGeolocate
                adaptiveScrollZoom={2000}
              >
                <BaseLayersUser key="bl" />
                <InfoLayer
                  key="gc"
                  noAutoFit
                  data={[geo_centroid]}
                  maxZoom={18}
                  markerProps={{ icon: marker('greenShield') }}
                />
                <InfoLayer
                  fitMaxZoom={17}
                  minZoom={19}
                  key="il"
                  data={[geo_centroid]}
                />
              </Maps>
            </div>
          </Col>
          <Col {...classes('col', 'info')} allPr={0}>
            <Trans lang="ru">
              <div {...classes('description')}>
                <p {...classes('text', 'address')} children="Киев, Семьи Кульженков 35, оф 1" />
                <p {...classes('text', 'tel')}>
                  <Link
                    {...classes('link', 'tel')}
                    href={`tel:${phoneHref}`}
                    external
                  >
                    <span {...classes('linkContent')}>
                      <span {...classes('text')} itemProp="telephone" children={phoneText} />
                    </span>
                  </Link>
                </p>
                <p {...classes('text', 'time')}>
                  {'работаем\u00a0'}<span itemProp="department">с ПН по ПТ с 9 до 18.00</span>{', Сб, Вс и праздничные дни - выходные.'}
                </p>
                <p {...classes('text')} children="Мы для себя выбрали писать правду, даже если это известный бренд или это наш клиент, который покупает рекламу. Дополнительные баллы нельзя ни купить, ни выменять на квадратные метры или доллары. Это наша принципиальная позиция." />
              </div>
            </Trans>
            <Trans lang="ua">
              <div {...classes('description')}>
                <p {...classes('text', 'address')} children="Київ, Сім'ї Кульженків 35, оф 1" />
                <p {...classes('text', 'tel')}>
                  <Link
                    {...classes('link', 'tel')}
                    href={`tel:${phoneHref}`}
                    external
                  >
                    <span {...classes('linkContent')}>
                      <span {...classes('text')} itemProp="telephone" children={phoneText} />
                    </span>
                  </Link>
                </p>
                <p {...classes('text', 'time')}>
                  {'працюємо\u00a0'}<span itemProp="department">з ПН по ПТ з 9 до 18.00</span>{', Сб, Нд та святкові дні - вихідні.'}
                </p>
                <p {...classes('text')} children="Ми для себе вибрали писати правду, навіть якщо це відомий бренд або це наш клієнт, який купує рекламу. Додаткові бали можна ні купити, ні виміняти на квадратні метри або долари. Це наша принципова позиція." />
              </div>
            </Trans>
            <Link
              {...classes('link', 'toAbout')}
              builder={links.sectionAbout}
              builderProps={{ title: i18n('moreDetailAboutUs') }}
            >
              <span {...classes('linkContent')}>
                <span {...classes('after')} />
                <span {...classes('text')} children={i18n('moreDetailAboutUs')} />
              </span>
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}
